import { render } from "./clubHome.vue?vue&type=template&id=1b6199ad"
import script from "./clubHome.vue?vue&type=script&lang=js"
export * from "./clubHome.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__